import { VisuallyHidden, screenMdMin, TextLink } from '@spotify-internal/encore-web';
import React from 'react';
import styled from 'styled-components';

import { MastheadBrand } from 'lib/sanity/types';
import { useServerSideConstants } from 'providers/ServerSideConstantsProvider';
import { urlForImage } from 'utils/sanity';

const StyledImage = styled.img`
  display: block;
  max-inline-size: 100%;
  height 36px;
  @media (max-width: ${screenMdMin}) {
    height: 28px;
  }
`;

const LinkWrapper = styled(TextLink)`
  && {
    text-decoration: none;

    &:focus {
      box-shadow: none;
      transition: none;
      outline: 5px auto -webkit-focus-ring-color;
    }
  }
`;

type Props = {
  brand: MastheadBrand;
};

export const NavBarLogo = ({ brand: { label, href, logo } }: Props) => {
  const {
    verticalConfig: { verticalName },
  } = useServerSideConstants();
  return (
    <LinkWrapper href={href} data-testid="navigation-logo">
      <StyledImage src={urlForImage({ source: logo.asset, maxWidth: 260, vertical: verticalName })} alt={label} />
      <VisuallyHidden>{label}</VisuallyHidden>
    </LinkWrapper>
  );
};
